import React from "react";
import VideoSubmissionContainer from "./styles/VideoSubmission.style";
import { Button } from "@material-ui/core";

export const SubmissionSection = ({ title, description, buttonText, buttonLink }) => (
  <div className="why-work-with-jukin-container">
    <h5 className="why-work-with-jukin-title">{title}</h5>
    <p className="why-work-with-jukin-description">{description}</p>
    <Button href={buttonLink} className="license-button" variant="contained">
      {buttonText}
    </Button>
  </div>
);

function VideoSubmission() {
  return (
    <VideoSubmissionContainer>
      <div className="video-submission-text-container">
        <h2 className="video-submission-title">Real Moments. Real Life.</h2>
      </div>

      <div className="video-submission-row-container">
        <SubmissionSection
          title="Why Work with Jukin?"
          description="We can help maximize the value of your video!"
          buttonText="Learn More"
          buttonLink="https://discover.jukinmedia.com/why-work-with-jukin"
        />
        <SubmissionSection
          title="Submit Video"
          description="Calling All Video Owners - Want to earn money on your video? Submit it here!"
          buttonText="Submit"
          buttonLink="/licensing/video-submissions"
        />
      </div>
    </VideoSubmissionContainer>
  );
}

export default VideoSubmission;
